import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { PageComponent } from '../../components/page/page.component';
import { BusinessHeaderComponent } from '../../components/business-header/business-header.component';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { NavigationService } from '../../services/navigation.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { LocationsModel } from '../../components/locations/locations-model';
import { BusinessLocationsModel } from '../../components/locations/business-locations-model';
import { BackendService } from '../../services/backend.service';
import { LocationsComponent } from '../../components/locations/locations.component';

@Component({
  selector: 'app-business-locations-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    ActionComponent,
    TranslateModule,
    BusinessHeaderComponent,
    LocationsComponent
  ],
  templateUrl: './business-locations-page.component.html',
  styleUrls: ['./business-locations-page.component.css']
})
export class BusinessLocationsPageComponent implements OnInit {

  businessId: string;
  locationsModel: LocationsModel;


  constructor(
      private sessionService: SessionService,
      private backendService: BackendService,
      private activatedRoute: ActivatedRoute,
      private navigationService: NavigationService) {
    this.businessId = '';
    this.locationsModel = new BusinessLocationsModel(this.businessId, this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.businessId = Util.safeString(pathParams.get('businessId'));
    this.locationsModel = new BusinessLocationsModel(this.businessId, this.backendService);
  }

  public goToAddLocationPage(): void {
    this.navigationService.goToAddLocationPage(this.businessId)
  }

  public goToBusinessPage(): void {
    this.navigationService.goToBusinessPage(this.businessId)
  }
}
